// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1074":"cdef8b96","1677":"958a43d4","2285":"958a43d4","3605":"d47fb1eb","5699":"d47fb1eb","7954":"d47fb1eb"}[chunkId] + ".chunk.css";
};